/* Höll · Bewegungen für die hoell-gh-* Sections (Grünhage-Look):
   Reveal-Stagger, Word-Mask-Überschriften, animierte Zähler.
   Ein Asset für alle Sections — initialisiert idempotent und erneut bei
   shopify:section:load, weil der Theme-Editor Sections neu rendert. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Überschriften ohne Inline-Markup in Wort-Masken zerlegen.
     Enthält das Heading em/strong/span, bleibt es ganz — es fährt dann
     als Block über den Reveal-Stagger ein (wie beim Original). */
  function splitWords(el) {
    if (el.dataset.hghWordsDone) return;
    el.dataset.hghWordsDone = '1';
    if (reduced) return;
    if (el.querySelector('em, i, strong, b, span, a')) return;
    el.classList.add('hgh-has-words');
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      if (i > 0) el.appendChild(document.createTextNode(' '));
      var mask = document.createElement('span');
      mask.className = 'hgh-word-mask';
      var inner = document.createElement('span');
      inner.className = 'hgh-word-inner';
      inner.textContent = w;
      mask.appendChild(inner);
      el.appendChild(mask);
    });
  }

  var revealIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-revealed');
            revealIO.unobserve(e.target);
          }
        });
      }, { threshold: 0.15 })
    : null;

  function runCounter(el) {
    if (el.dataset.hghCounted) return;
    el.dataset.hghCounted = '1';
    var target = parseInt(el.getAttribute('data-hgh-counter'), 10) || 0;
    var suffix = el.getAttribute('data-hgh-suffix') || '';
    var duration = 1500;
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var counterIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          runCounter(e.target);
          counterIO.unobserve(e.target);
        });
      }, { threshold: 0.4 })
    : null;

  function scan(root) {
    root = root && root.querySelectorAll ? root : document;

    root.querySelectorAll('[data-hgh-words]').forEach(splitWords);

    root.querySelectorAll('[data-hgh-reveal]').forEach(function (el) {
      if (el.dataset.hghBound) return;
      el.dataset.hghBound = '1';
      if (reduced || !revealIO) { el.classList.add('is-revealed'); return; }
      revealIO.observe(el);
    });

    root.querySelectorAll('[data-hgh-counter]').forEach(function (el) {
      if (el.dataset.hghCbound) return;
      el.dataset.hghCbound = '1';
      /* Im Markup steht der Endwert (No-JS-Fallback) — erst hier auf 0 setzen. */
      if (reduced || !counterIO) return;
      el.textContent = '0';
      counterIO.observe(el);
    });
  }

  /* Fallback: bereits sichtbare Elemente sofort aufdecken (z. B. Anker-Sprung). */
  function revealVisible() {
    if (reduced) return;
    var vh = window.innerHeight;
    document.querySelectorAll('[data-hgh-reveal]:not(.is-revealed)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) {
        el.classList.add('is-revealed');
        if (revealIO) revealIO.unobserve(el);
      }
    });
  }

  function init() { scan(document); revealVisible(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', revealVisible);
  window.addEventListener('scroll', revealVisible, { passive: true });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') revealVisible();
  });
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
    revealVisible();
  });
})();
